import { render, staticRenderFns } from "./subproperty-list-filter.vue?vue&type=template&id=23c2e4a7&scoped=true&"
import script from "./subproperty-list-filter.vue?vue&type=script&lang=js&"
export * from "./subproperty-list-filter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c2e4a7",
  null
  
)

export default component.exports